
import {useQuery, gql} from "@apollo/client";

var SEARCH_PAGE_HEADER = gql`
query MyQuery {
    searchPageHeader {
      displayText
      searchPageHeader {
        urls(first: 1)
      }
    }
  }
  `;

export const useSearchPageHeader = () => {
    const {error, data, loading} = useQuery(SEARCH_PAGE_HEADER);
    return {
      error,
      data,
      loading
    }
  }


  